/**
 * States used by UI_TournamentIcon and UI_DailyChallengeIcon
 */
export const ICON_STATES = {
  ACTIVE: 0,
  COOLDOWN: 1,
  PROMO: 2,
};
